import injectTooltip from './injectTooltip';
export default injectTooltip;



// WEBPACK FOOTER //
// ./src/js/Tooltips/index.js